import React from 'react';
import {connect} from 'react-redux';

import {reverse} from 'utils/urls';
import {LOCATION_LIST_URL} from 'config/urls';

import LoginRequired from 'components/LoginRequired';
import {LocationBox} from './components';

import {fetchLocations, selectLocations} from 'ducks/locations';
import {
  requiresPermission,
  PERMISSIONS,
  redirectToDefaultPage
} from 'ducks/auth';

import './styles.css';

export const breadcrumbFactory = () => {
  return {
    parent: null,
    label: 'Locations',
    url: reverse(LOCATION_LIST_URL, {})
  };
};

class LocationsPage extends React.Component<any> {
  componentDidMount() {
    this.props.fetchLocations();
  }

  goToFrontDesk = locationRef =>
    this.props.requiresPermission(
      {locationRef, permission: PERMISSIONS.VIEW_LOCATION_DETAIL},
      () => this.props.redirectToDefaultPage({locationRef})
    );

  render() {
    const {locations} = this.props;

    return (
      <div className="LocationsPage">
        <div className="content">
          <div className="welcomeText">
            <div className="heading colab-bold">Welcome to Colab</div>
            <div className="subHeading">Select a location</div>
          </div>
          <div className="listContainer">
            {locations.map(location => (
              <LocationBox
                onClick={this.goToFrontDesk}
                key={location.ref}
                location={location}
                className="locationBoxWrapper"
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const locations = selectLocations(state);
  return {locations};
};

const mapDispatchToProps = {
  fetchLocations,
  requiresPermission,
  redirectToDefaultPage
};

export default connect(mapStateToProps, mapDispatchToProps)(
  LoginRequired(LocationsPage)
);
